var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5212 12.597C30.4148 12.5562 30.3125 12.5357 30.2142 12.5357C29.9932 12.5357 29.8092 12.6136 29.6618 12.769L24.7142 17.7044V15.6787C24.7142 14.7046 24.3684 13.872 23.6768 13.1803C22.9851 12.4888 22.1525 12.1429 21.1784 12.1429H12.5356C11.5618 12.1429 10.729 12.4888 10.0372 13.1803C9.34581 13.872 9 14.7046 9 15.6787V24.3216C9 25.2956 9.34581 26.1282 10.0373 26.8198C10.729 27.5114 11.5618 27.8572 12.5357 27.8572H21.1785C22.1526 27.8572 22.9852 27.5114 23.6769 26.8198C24.3685 26.1282 24.7143 25.2956 24.7143 24.3216V22.2835L29.6619 27.2311C29.8093 27.3865 29.9933 27.4643 30.2143 27.4643C30.3126 27.4643 30.4149 27.4439 30.5213 27.4031C30.8406 27.2639 31.0001 27.0226 31.0001 26.6788V13.3215C31 12.9776 30.8405 12.7362 30.5212 12.597Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera2);
export default __webpack_public_path__ + "static/media/camera2.b18d389dd9d044ecb1aecd93548c84cc.svg";
export { ForwardRef as ReactComponent };